/**
 * Stable URL slugs for blog posts (path-based URLs for indexing).
 * Keep in sync with vercel.json redirects from /blog?post=id.
 */
export const BLOG_POST_SLUG_BY_ID: Record<string, string> = {
  '1': 'top-10-cleaning-services-kakkanad-2025-guide',
  '2': 'deep-cleaning-vs-regular-cleaning-kakkanad-homes',
  '3': 'edappally-metro-cleaning-apartments-guide',
  '4': '5-signs-kochi-home-needs-deep-cleaning',
  '5': 'tools-bubbles-same-day-service-kochi',
  '6': 'best-house-cleaning-services-kochi-2026',
  '7': 'sofa-cleaning-services-kochi-prices-2026',
  '8': 'deep-cleaning-checklist-kochi-homes',
  '9': 'post-construction-cleaning-kochi-2026',
  '10': 'kitchen-deep-cleaning-kochi-guide',
  '11': 'bathroom-deep-cleaning-kochi-anti-fungal',
  '12': 'office-cleaning-services-kochi-guide',
  '13': 'carpet-cleaning-kochi-steam-vs-dry',
  '14': 'move-in-move-out-cleaning-kochi',
  '15': 'mattress-cleaning-kochi-dust-mites',
  '16': 'cleaning-service-kochi-google-rank-1',
  '17': 'water-tank-cleaning-kochi-2026',
  '18': 'palarivattom-kaloor-cleaning-guide-2026',
  '19': 'monsoon-cleaning-tips-kochi',
  '20': 'google-reviews-gmb-cleaning-service-kochi',
  '21': 'marine-drive-panampilly-cleaning-2026',
  '22': 'fort-kochi-mattancherry-cleaning-guide',
  '23': 'kadavanthra-vyttila-cleaning-services-2026',
  '24': 'ac-duct-cleaning-kochi-2026',
  '25': 'pre-onam-festival-cleaning-kochi-2026',
  '26': 'choose-cleaning-service-kochi-buyer-guide',
  '27': 'aluva-kalamassery-cleaning-guide-2026',
  '28': 'eco-friendly-cleaning-services-kochi-2026',
  '29': 'tile-grout-cleaning-kochi-2026',
  '30': 'thripunithura-kakkanad-east-cleaning-2026',
  '31': 'cleaning-service-cost-kochi-price-guide-2026',
  '32': 'apartment-vs-villa-cleaning-kochi-2026',
  '33': 'find-cleaning-services-kochi-directories-2026',
  '34': 'summer-deep-cleaning-kochi-2026',
  '35': 'why-tools-bubbles-number-1-kochi',
  '36': 'window-glass-cleaning-kochi-2026',
  '37': 'post-diwali-cleaning-kochi-2026',
  '38': 'recurring-monthly-cleaning-kochi-2026',
  '39': 'deep-cleaning-near-me-kochi-2026',
  '40': 'same-day-cleaning-kochi-how-to-book-2026',
  '41': 'maid-service-vs-professional-cleaning-kochi-2026',
  '42': 'cleaning-service-vennala-elamkulam-2026',
  '43': 'vazhakkala-smart-city-cleaning-guide-2026',
  '44': 'thevara-nettoor-palluruthy-cleaning-2026',
  '45': 'elamakkara-thammanam-cheranalloor-cleaning-2026',
  '46': 'how-to-book-cleaning-service-online-kochi-2026',
  '47': 'professional-cleaners-near-me-kochi-2026',
  '48': 'housekeeping-services-kochi-offices-homes-2026',
  '49': 'irumpanam-spa-road-apartment-cleaning-2026',
  '50': 'monsoon-bathroom-cleaning-kochi-2026',
  '51': 'water-tank-cleaning-kochi-apartments-2026',
  '52': 'same-day-house-cleaning-neighbourhoods-kochi-2026',
};
